module.exports = __webpack_public_path__ + "static/media/archibot-incompris.a51cb18a.gif";